import { faBell } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { usePushNotification } from '../../hooks/usePushNotification';

const ROUTE_MESSAGES = {
    '/notification': 'Bật thông báo để nhận thông tin mới',
    '/user-info/withdraw': 'Bật thông báo để nhận thông tin rút tiền',
    '/user-info/order': 'Bật thông báo để nhận thông tin đơn hàng ghi nhận hoặc hoàn tiền',
};

function NotificationPrompt() {
    const location = useLocation();
    const navigate = useNavigate();
    const { isSubscribed, isSupported } = usePushNotification();

    // Don't show if notifications are not supported
    if (!isSupported) {
        return null;
    }

    // Don't show if already subscribed
    if (isSubscribed) {
        return null;
    }

    // Get message for current route
    const message = ROUTE_MESSAGES[location.pathname];

    // Don't show if no message for this route
    if (!message) {
        return null;
    }

    const handleClick = () => {
        navigate('/user-info');
    };

    return (
        <div
            onClick={handleClick}
            className="flex items-center gap-2 px-3 py-2 bg-amber-50 border-l-4 border-amber-400 text-sm text-amber-800 cursor-pointer hover:bg-amber-100 transition-colors"
        >
            <FontAwesomeIcon icon={faBell} className="text-base" />
            <span className="flex-1">{message}</span>
            <span className="text-xs font-semibold text-amber-600">Bật ngay →</span>
        </div>
    );
}

export default NotificationPrompt;

